import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Home() {
  // Background images for slideshow
  const images = [
    "/images/craftman6.jpg",
    "/images/craftman9.jpg",
    "/images/craftman12.jpg",
    "/images/craftman4.jpg",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto change background every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  const clients = [
    { code: "us", title: "USA" },
    { code: "ae", title: "UAE" },
    { code: "gb", title: "UK" },
    { code: "in", title: "India" },
    { code: "ca", title: "Canada" },
    { code: "au", title: "Australia" },
  ];

  return (
    <div>
      {/* Hero Section with Slideshow */}
      <div
        className="hero-section text-white text-center d-flex align-items-center justify-content-center"
        style={{
          backgroundImage: `url(${images[currentIndex]})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "85vh",
          position: "relative",
          transition: "background-image 1s ease-in-out",
        }}
      >
        {/* Dark Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6))",
          }}
        ></div>

        {/* Content */}
        <div style={{ position: "relative", zIndex: 2, animation: "fadeIn 2s ease" }}>
          <h1 className="display-3 fw-bold hero-title">Welcome to LegendImpex</h1>
          <p className="lead fs-4 mb-4">Handmade Premium Leather Bags, Belts & Wallets</p>
          <Link to="/products" className="btn btn-light btn-lg px-4 shadow explore-btn">
            Explore Products
          </Link>
        </div>
      </div>

      {/* Highlights Section */}
      <div className="container my-5">
        <h2 className="section-heading text-center mb-5">Why Choose Us</h2>
        <div className="row text-center g-4">
          <div className="col-md-4">
            <div className="p-4 border rounded shadow-sm h-100 hover-card">
              <i className="fas fa-gem fa-2x mb-3 text-warning"></i>
              <h3 className="fw-bold">Premium Quality</h3>
              <p>Only the finest leather, crafted with care and precision.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-4 border rounded shadow-sm h-100 hover-card">
              <i className="fas fa-hand-paper fa-2x mb-3 text-primary"></i>
              <h3 className="fw-bold">Handmade</h3>
              <p>Each product is uniquely handmade by skilled artisans.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-4 border rounded shadow-sm h-100 hover-card">
              <i className="fas fa-infinity fa-2x mb-3 text-success"></i>
              <h3 className="fw-bold">Long Lasting</h3>
              <p>Durable leather designed to last for generations.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Products */}
      <div className="container my-5">
        <h2 className="section-heading text-center mb-4">Our Masterpieces</h2>
        <div className="row g-4">
          {[
            { img: "/images/new_photos/wallet1.jpeg", title: "Leather Wallet" },
            { img: "/images/bag11.jpg", title: "Leather Bag" },
            { img: "/images/jacket.jpeg", title: "Leather Jacket" },
            { img: "/images/new_photos/purse2.jpeg", title: "Leather Purse" },
            { img: "/images/belt2.png", title: "Leather Belt" },
            { img: "/images/craftman1.png", title: "CraftMan at Work" },
          ].map((item, i) => (
            <div className="col-md-4" key={i}>
              <div className="card shadow-sm product-card h-100">
                <div className="img-container">
                  <img
                    src={item.img}
                    className="card-img-top"
                    alt={item.title}
                    style={{ height: "300px", objectFit: "cover" }}
                  />
                </div>
                <div className="card-body text-center">
                  <h5 className="card-title">{item.title}</h5>
                  <Link to="/products" className="btn btn-outline-dark btn-sm mt-2">
                    View More
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Our Clients Section */}
      <div className="container my-5">
        <h2 className="section-heading text-center mb-4">Our Global Clients</h2>
        <div className="client-carousel">
          <div className="client-track">
            {clients.concat(clients).map((client, i) => (
              <div className="client-item" key={i}>
                <img
                  src={`https://flagcdn.com/w80/${client.code}.png`}
                  alt={client.title}
                  title={client.title}
                  style={{
                    width: "80px",
                    height: "auto",
                    borderRadius: "6px",
                    transition: "transform 0.3s ease",
                  }}
                />
                <h6 className="mt-2">{client.title}</h6>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Enhanced Location Map Section */}
      <div className="container my-5">
        <h2 className="section-heading text-center mb-4">Our Location</h2>
        <div className="map-card position-relative overflow-hidden rounded shadow-lg">
          <iframe
            title="LegendImpex Location"
            src="https://www.google.com/maps?q=12/35+A+Talimabad,+Sangam+Vihar,+New+Delhi-110080&output=embed"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
          {/* Address Overlay */}
          <div className="map-overlay p-3 text-white">
            <h5 className="mb-1 fw-bold">LegendImpex</h5>
            <p className="mb-0">12/35 A Talimabad, Sangam Vihar, New Delhi-110080</p>
          </div>
        </div>
      </div>

      {/* Custom CSS */}
      <style>
        {`
          .hero-title {
            background: linear-gradient(to right, #ffdd00, #ff6a00);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          .explore-btn:hover {
            transform: scale(1.05);
            transition: 0.3s;
          }
          .hover-card {
            transition: all 0.3s ease-in-out;
          }
          .hover-card:hover {
            background-color: #f8f9fa;
            transform: translateY(-5px);
          }
          .product-card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .product-card:hover {
            transform: translateY(-8px);
            box-shadow: 0px 8px 20px rgba(0,0,0,0.2);
          }
          .img-container {
            overflow: hidden;
          }
          .img-container img {
            transition: transform 0.4s ease;
          }
          .img-container img:hover {
            transform: scale(1.1);
          }
          .section-heading {
            font-size: 2.2rem;
            font-weight: 700;
            position: relative;
            display: inline-block;
          }
          .section-heading::after {
            content: "";
            display: block;
            width: 60px;
            height: 4px;
            background: #ff6a00;
            margin: 10px auto 0;
            border-radius: 2px;
          }
          .client-carousel {
            overflow: hidden;
            position: relative;
            width: 100%;
          }
          .client-track {
            display: flex;
            width: max-content;
            animation: scroll 20s linear infinite;
          }
          .client-item {
            flex: 0 0 auto;
            text-align: center;
            margin: 0 30px;
          }
          .client-item img:hover {
            transform: scale(1.2);
          }
          .map-card {
            border-radius: 15px;
            overflow: hidden;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .map-card:hover {
            transform: scale(1.02);
            box-shadow: 0 15px 35px rgba(0,0,0,0.25);
          }
          .map-overlay {
            position: absolute;
            bottom: 15px;
            left: 15px;
            background: rgba(0,0,0,0.55);
            border-radius: 10px;
          }
          .map-overlay h5, .map-overlay p {
            margin: 0;
          }
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
}
